// extracted by mini-css-extract-plugin
export default {"spinner":"App_spinner_un_C1"};